import { useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import { accessRolesState } from '../states/access-roles-state'
import axios from 'axios'
import { getServerHost } from '../utils/get-server-host'
import { getHeaders } from '../utils/get-headers'

export const fetchAccessRoles = async () => {
  try {
    const result = await axios.get(getServerHost('access-roles'), { headers: getHeaders() })

    if (result.status === 200) {
      return result.data.accessRoles
    }
  } catch (error) {
    console.log(error)
  }
}

export const useFetchAccessRoles = () => {
  const set = useSetRecoilState(accessRolesState)

  return useCallback(async () => {
    const items = await fetchAccessRoles()

    if (Array.isArray(items)) {
      set(items)
    }
  }, [])
}